'use client';

import { Fragment } from 'react';
import styles from './ProjectBoardSection.module.scss';
import { useAOS } from '@/src/lib/hooks/useAOS';
import { ProjectBoard } from '../ProjectBoard/ProjectBoard';

export interface ProjectBoardSectionProps {
  eyebrow?: string;
  title?: string;
  step?: number;
  showQualityDashboard?: boolean;
  showTicketBoard?: boolean;
  compact?: boolean;
  accentColor?: 'gold' | 'gray';
  tilt?: 'left' | 'right';
  illustrativeLabel?: string;
  lang?: string;
}

const renderTitle = (title: string) => {
  const parts = title.split('*');
  return parts.map((part, i) => {
    if (i % 2 === 1) {
      return <em key={i}>{part}</em>;
    }
    const segments = part.split('—');
    return segments.map((segment, j) => (
      <Fragment key={j}>
        {segment}
        {j < segments.length - 1 && <span className={styles.titleDash}>—</span>}
      </Fragment>
    ));
  });
};

export const ProjectBoardSection = ({
  eyebrow = '',
  title = 'Un *responsable delivery* — qui rend chaque étape *transparente* et la fait progresser grâce aux *données*.',
  step,
  showQualityDashboard = true,
  showTicketBoard = true,
  compact = false,
  accentColor = 'gray',
  tilt,
  illustrativeLabel,
  lang = 'fr',
}: ProjectBoardSectionProps) => {
  useAOS();

  const tiltClass = tilt ? (tilt === 'left' ? styles.tiltLeft : styles.tiltRight) : '';

  return (
    <div className={`${styles.root} ${tiltClass}`}>
      <div className={styles.header}>
        {eyebrow && (
          <div className={styles.eyebrowRow}>
            {step && (
              <span
                className={styles.stepBadge}
                data-aos="fade-down"
                data-aos-duration="600"
                data-aos-once="true"
              >
                {step}
              </span>
            )}
            <p className={styles.eyebrow}>{eyebrow}</p>
          </div>
        )}
        {title && (
          <h2 className={`${styles.title} ${accentColor === 'gold' ? styles.titleGold : ''}`}>
            {renderTitle(title)}
          </h2>
        )}
      </div>
      <ProjectBoard
        showQualityDashboard={showQualityDashboard}
        showTicketBoard={showTicketBoard}
        compact={compact}
        illustrativeLabel={illustrativeLabel}
        lang={lang}
      />
    </div>
  );
};
